import { conversationMediaState } from '../singleton';

export const useSetMessageMediaContent = () => {
  const setMediaContent = conversationMediaState((s) => s.setMediaContent);

  return { setMediaContent };
};
